import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
import { TapBackground } from '../TapBackground';
import { SdfBackground } from '../SdfBackground';
import { TriolietBackground } from '../TriolietBackground';
import { OilSteelBackground } from '../OilSteelBackground';
import { FallbackBackground } from '../FallbackBackground';
import { TritecnicaBackground } from '../TritecnicaBackground';
import { KVBackground } from '../KVBackground';
import HubfarmBackground from '../HubfarmBackground';
const styles = (theme) => createStyles({
    '@global': {
        body: {
            fontFamily: theme.font.family,
            backgroundColor: theme.color.grey.lightest,
            height: '100%',
            margin: 0,
        },
    },
});
const mapByTenant = {
    topcon: TapBackground,
    sdf: SdfBackground,
    oilsteel: OilSteelBackground,
    tritecnica: TritecnicaBackground,
    trioliet: TriolietBackground,
    kverneland: KVBackground,
    hubfarm: HubfarmBackground,
};
const PlatformPublicLayout = (props) => {
    var _a;
    const { fullScrollMode, children, onClick, hideLogo, tenantName = 'fallBack', imagesBaseUrl = 'https://tapprodstoragecommon.blob.core.windows.net/graphic-resources', } = props;
    const mainContainerStyle = {
        overflowY: fullScrollMode ? 'auto' : 'hidden',
    };
    const PageBackground = (_a = mapByTenant[tenantName]) !== null && _a !== void 0 ? _a : FallbackBackground;
    return (React.createElement("main", { onClick: onClick, style: mainContainerStyle },
        React.createElement(PageBackground, { hideLogo: hideLogo, imagesBaseUrl: imagesBaseUrl }, children)));
};
export default compose(withBaseProps({ styles }))(PlatformPublicLayout);
//# sourceMappingURL=PlatformPublicLayout.js.map